import axiosClient from "../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/background-check-applicant-form-data/${id}`)

    return result.data
}
